/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BitbucketRepositoryData } from '../model';
// @ts-ignore
import type { Connector } from '../model';
// @ts-ignore
import type { ConnectorIntegration } from '../model';
// @ts-ignore
import type { ConnectorIntegrationBulkUpdate } from '../model';
// @ts-ignore
import type { ConnectorIntegrationUpdate } from '../model';
// @ts-ignore
import type { ConnectorType } from '../model';
// @ts-ignore
import type { CreateConnectorRequest } from '../model';
// @ts-ignore
import type { GithubRepositoryData } from '../model';
// @ts-ignore
import type { GoogleDriveFilesRequest } from '../model';
// @ts-ignore
import type { GoogleDriveFilesResponse } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { OAuthCallbackRequest } from '../model';
// @ts-ignore
import type { OAuthCallbackResponse } from '../model';
// @ts-ignore
import type { OAuthInitiateResponse } from '../model';
// @ts-ignore
import type { UpdateConnectorRequest } from '../model';
/**
 * ConnectorsApi - axios parameter creator
 */
export const ConnectorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update multiple organization integration\'s enabled status.
         * @summary Update Supported Connector Types
         * @param {ConnectorIntegrationBulkUpdate} connectorIntegrationBulkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateSupportedConnectorTypes: async (connectorIntegrationBulkUpdate: ConnectorIntegrationBulkUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorIntegrationBulkUpdate' is not null or undefined
            assertParamExists('bulkUpdateSupportedConnectorTypes', 'connectorIntegrationBulkUpdate', connectorIntegrationBulkUpdate)
            const localVarPath = `/connectors/supported-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectorIntegrationBulkUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new connector with OAuth credentials
         * @summary Create Connector
         * @param {CreateConnectorRequest} createConnectorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnector: async (createConnectorRequest: CreateConnectorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createConnectorRequest' is not null or undefined
            assertParamExists('createConnector', 'createConnectorRequest', createConnectorRequest)
            const localVarPath = `/connectors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createConnectorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a connector and its associated OAuth tokens
         * @summary Delete Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConnector: async (connectorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorId' is not null or undefined
            assertParamExists('deleteConnector', 'connectorId', connectorId)
            const localVarPath = `/connectors/{connector_id}`
                .replace('{connector_id}', encodeURIComponent(String(connectorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Bitbucket Repositories
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBitbucketRepositories: async (connectorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorId' is not null or undefined
            assertParamExists('getBitbucketRepositories', 'connectorId', connectorId)
            const localVarPath = `/connectors/bitbucket/{connector_id}/repositories`
                .replace('{connector_id}', encodeURIComponent(String(connectorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific connector by ID
         * @summary Get Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnector: async (connectorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorId' is not null or undefined
            assertParamExists('getConnector', 'connectorId', connectorId)
            const localVarPath = `/connectors/{connector_id}`
                .replace('{connector_id}', encodeURIComponent(String(connectorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Github Repositories
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGithubRepositories: async (connectorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorId' is not null or undefined
            assertParamExists('getGithubRepositories', 'connectorId', connectorId)
            const localVarPath = `/connectors/github/{connector_id}/repositories`
                .replace('{connector_id}', encodeURIComponent(String(connectorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all supported OAuth connector types
         * @summary Get Supported Connector Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedConnectorTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connectors/supported-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchange authorization code for OAuth tokens
         * @summary Handle OAuth Callback
         * @param {ConnectorType} connectorType 
         * @param {OAuthCallbackRequest} oAuthCallbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleOauthCallback: async (connectorType: ConnectorType, oAuthCallbackRequest: OAuthCallbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorType' is not null or undefined
            assertParamExists('handleOauthCallback', 'connectorType', connectorType)
            // verify required parameter 'oAuthCallbackRequest' is not null or undefined
            assertParamExists('handleOauthCallback', 'oAuthCallbackRequest', oAuthCallbackRequest)
            const localVarPath = `/connectors/{connector_type}/auth/callback`
                .replace('{connector_type}', encodeURIComponent(String(connectorType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(oAuthCallbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate authorization URL to start OAuth flow for a connector type
         * @summary Initiate OAuth Flow
         * @param {ConnectorType} connectorType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateOauth: async (connectorType: ConnectorType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorType' is not null or undefined
            assertParamExists('initiateOauth', 'connectorType', connectorType)
            const localVarPath = `/connectors/{connector_type}/auth/initiate`
                .replace('{connector_type}', encodeURIComponent(String(connectorType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all connectors for the current user
         * @summary List Connectors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/connectors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List files and folders in Google Drive with pagination.
         * @summary List Google Drive Files
         * @param {string} connectorId 
         * @param {GoogleDriveFilesRequest} googleDriveFilesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGoogleDriveFiles: async (connectorId: string, googleDriveFilesRequest: GoogleDriveFilesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorId' is not null or undefined
            assertParamExists('listGoogleDriveFiles', 'connectorId', connectorId)
            // verify required parameter 'googleDriveFilesRequest' is not null or undefined
            assertParamExists('listGoogleDriveFiles', 'googleDriveFilesRequest', googleDriveFilesRequest)
            const localVarPath = `/connectors/google-drive/{connector_id}/files`
                .replace('{connector_id}', encodeURIComponent(String(connectorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(googleDriveFilesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate OAuth flow to refresh expired connector credentials
         * @summary Re-authorize Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reauthorizeConnector: async (connectorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorId' is not null or undefined
            assertParamExists('reauthorizeConnector', 'connectorId', connectorId)
            const localVarPath = `/connectors/{connector_id}/reauthorize`
                .replace('{connector_id}', encodeURIComponent(String(connectorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke the connector\'s OAuth credentials at the provider and clear the stored tokens
         * @summary Revoke Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeConnector: async (connectorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorId' is not null or undefined
            assertParamExists('revokeConnector', 'connectorId', connectorId)
            const localVarPath = `/connectors/{connector_id}/revoke`
                .replace('{connector_id}', encodeURIComponent(String(connectorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing connector
         * @summary Update Connector
         * @param {string} connectorId 
         * @param {UpdateConnectorRequest} updateConnectorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConnector: async (connectorId: string, updateConnectorRequest: UpdateConnectorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorId' is not null or undefined
            assertParamExists('updateConnector', 'connectorId', connectorId)
            // verify required parameter 'updateConnectorRequest' is not null or undefined
            assertParamExists('updateConnector', 'updateConnectorRequest', updateConnectorRequest)
            const localVarPath = `/connectors/{connector_id}`
                .replace('{connector_id}', encodeURIComponent(String(connectorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateConnectorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an organization integration\'s enabled status.
         * @summary Update Supported Connector Types
         * @param {ConnectorIntegrationUpdate} connectorIntegrationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportedConnectorTypes: async (connectorIntegrationUpdate: ConnectorIntegrationUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorIntegrationUpdate' is not null or undefined
            assertParamExists('updateSupportedConnectorTypes', 'connectorIntegrationUpdate', connectorIntegrationUpdate)
            const localVarPath = `/connectors/supported-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectorIntegrationUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConnectorsApi - functional programming interface
 */
export const ConnectorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConnectorsApiAxiosParamCreator(configuration)
    return {
        /**
         * Update multiple organization integration\'s enabled status.
         * @summary Update Supported Connector Types
         * @param {ConnectorIntegrationBulkUpdate} connectorIntegrationBulkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateSupportedConnectorTypes(connectorIntegrationBulkUpdate: ConnectorIntegrationBulkUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConnectorIntegration>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateSupportedConnectorTypes(connectorIntegrationBulkUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.bulkUpdateSupportedConnectorTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new connector with OAuth credentials
         * @summary Create Connector
         * @param {CreateConnectorRequest} createConnectorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConnector(createConnectorRequest: CreateConnectorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Connector>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConnector(createConnectorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.createConnector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a connector and its associated OAuth tokens
         * @summary Delete Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConnector(connectorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConnector(connectorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.deleteConnector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Bitbucket Repositories
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBitbucketRepositories(connectorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BitbucketRepositoryData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBitbucketRepositories(connectorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.getBitbucketRepositories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific connector by ID
         * @summary Get Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnector(connectorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Connector>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnector(connectorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.getConnector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Github Repositories
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGithubRepositories(connectorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GithubRepositoryData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGithubRepositories(connectorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.getGithubRepositories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all supported OAuth connector types
         * @summary Get Supported Connector Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedConnectorTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConnectorIntegration>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedConnectorTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.getSupportedConnectorTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exchange authorization code for OAuth tokens
         * @summary Handle OAuth Callback
         * @param {ConnectorType} connectorType 
         * @param {OAuthCallbackRequest} oAuthCallbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleOauthCallback(connectorType: ConnectorType, oAuthCallbackRequest: OAuthCallbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthCallbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleOauthCallback(connectorType, oAuthCallbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.handleOauthCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate authorization URL to start OAuth flow for a connector type
         * @summary Initiate OAuth Flow
         * @param {ConnectorType} connectorType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateOauth(connectorType: ConnectorType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthInitiateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateOauth(connectorType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.initiateOauth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all connectors for the current user
         * @summary List Connectors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConnectors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Connector>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConnectors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.listConnectors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List files and folders in Google Drive with pagination.
         * @summary List Google Drive Files
         * @param {string} connectorId 
         * @param {GoogleDriveFilesRequest} googleDriveFilesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGoogleDriveFiles(connectorId: string, googleDriveFilesRequest: GoogleDriveFilesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleDriveFilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGoogleDriveFiles(connectorId, googleDriveFilesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.listGoogleDriveFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiate OAuth flow to refresh expired connector credentials
         * @summary Re-authorize Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reauthorizeConnector(connectorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthInitiateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reauthorizeConnector(connectorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.reauthorizeConnector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke the connector\'s OAuth credentials at the provider and clear the stored tokens
         * @summary Revoke Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeConnector(connectorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Connector>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeConnector(connectorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.revokeConnector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing connector
         * @summary Update Connector
         * @param {string} connectorId 
         * @param {UpdateConnectorRequest} updateConnectorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConnector(connectorId: string, updateConnectorRequest: UpdateConnectorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Connector>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConnector(connectorId, updateConnectorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.updateConnector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an organization integration\'s enabled status.
         * @summary Update Supported Connector Types
         * @param {ConnectorIntegrationUpdate} connectorIntegrationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSupportedConnectorTypes(connectorIntegrationUpdate: ConnectorIntegrationUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectorIntegration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupportedConnectorTypes(connectorIntegrationUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.updateSupportedConnectorTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConnectorsApi - factory interface
 */
export const ConnectorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConnectorsApiFp(configuration)
    return {
        /**
         * Update multiple organization integration\'s enabled status.
         * @summary Update Supported Connector Types
         * @param {ConnectorsApiBulkUpdateSupportedConnectorTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateSupportedConnectorTypes(requestParameters: ConnectorsApiBulkUpdateSupportedConnectorTypesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConnectorIntegration>> {
            return localVarFp.bulkUpdateSupportedConnectorTypes(requestParameters.connectorIntegrationBulkUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new connector with OAuth credentials
         * @summary Create Connector
         * @param {ConnectorsApiCreateConnectorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnector(requestParameters: ConnectorsApiCreateConnectorRequest, options?: RawAxiosRequestConfig): AxiosPromise<Connector> {
            return localVarFp.createConnector(requestParameters.createConnectorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a connector and its associated OAuth tokens
         * @summary Delete Connector
         * @param {ConnectorsApiDeleteConnectorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConnector(requestParameters: ConnectorsApiDeleteConnectorRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteConnector(requestParameters.connectorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Bitbucket Repositories
         * @param {ConnectorsApiGetBitbucketRepositoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBitbucketRepositories(requestParameters: ConnectorsApiGetBitbucketRepositoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BitbucketRepositoryData>> {
            return localVarFp.getBitbucketRepositories(requestParameters.connectorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific connector by ID
         * @summary Get Connector
         * @param {ConnectorsApiGetConnectorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnector(requestParameters: ConnectorsApiGetConnectorRequest, options?: RawAxiosRequestConfig): AxiosPromise<Connector> {
            return localVarFp.getConnector(requestParameters.connectorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Github Repositories
         * @param {ConnectorsApiGetGithubRepositoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGithubRepositories(requestParameters: ConnectorsApiGetGithubRepositoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GithubRepositoryData>> {
            return localVarFp.getGithubRepositories(requestParameters.connectorId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all supported OAuth connector types
         * @summary Get Supported Connector Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedConnectorTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<ConnectorIntegration>> {
            return localVarFp.getSupportedConnectorTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * Exchange authorization code for OAuth tokens
         * @summary Handle OAuth Callback
         * @param {ConnectorsApiHandleOauthCallbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleOauthCallback(requestParameters: ConnectorsApiHandleOauthCallbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<OAuthCallbackResponse> {
            return localVarFp.handleOauthCallback(requestParameters.connectorType, requestParameters.oAuthCallbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate authorization URL to start OAuth flow for a connector type
         * @summary Initiate OAuth Flow
         * @param {ConnectorsApiInitiateOauthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateOauth(requestParameters: ConnectorsApiInitiateOauthRequest, options?: RawAxiosRequestConfig): AxiosPromise<OAuthInitiateResponse> {
            return localVarFp.initiateOauth(requestParameters.connectorType, options).then((request) => request(axios, basePath));
        },
        /**
         * List all connectors for the current user
         * @summary List Connectors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectors(options?: RawAxiosRequestConfig): AxiosPromise<Array<Connector>> {
            return localVarFp.listConnectors(options).then((request) => request(axios, basePath));
        },
        /**
         * List files and folders in Google Drive with pagination.
         * @summary List Google Drive Files
         * @param {ConnectorsApiListGoogleDriveFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGoogleDriveFiles(requestParameters: ConnectorsApiListGoogleDriveFilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GoogleDriveFilesResponse> {
            return localVarFp.listGoogleDriveFiles(requestParameters.connectorId, requestParameters.googleDriveFilesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate OAuth flow to refresh expired connector credentials
         * @summary Re-authorize Connector
         * @param {ConnectorsApiReauthorizeConnectorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reauthorizeConnector(requestParameters: ConnectorsApiReauthorizeConnectorRequest, options?: RawAxiosRequestConfig): AxiosPromise<OAuthInitiateResponse> {
            return localVarFp.reauthorizeConnector(requestParameters.connectorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke the connector\'s OAuth credentials at the provider and clear the stored tokens
         * @summary Revoke Connector
         * @param {ConnectorsApiRevokeConnectorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeConnector(requestParameters: ConnectorsApiRevokeConnectorRequest, options?: RawAxiosRequestConfig): AxiosPromise<Connector> {
            return localVarFp.revokeConnector(requestParameters.connectorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing connector
         * @summary Update Connector
         * @param {ConnectorsApiUpdateConnectorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConnector(requestParameters: ConnectorsApiUpdateConnectorRequest, options?: RawAxiosRequestConfig): AxiosPromise<Connector> {
            return localVarFp.updateConnector(requestParameters.connectorId, requestParameters.updateConnectorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an organization integration\'s enabled status.
         * @summary Update Supported Connector Types
         * @param {ConnectorsApiUpdateSupportedConnectorTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportedConnectorTypes(requestParameters: ConnectorsApiUpdateSupportedConnectorTypesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectorIntegration> {
            return localVarFp.updateSupportedConnectorTypes(requestParameters.connectorIntegrationUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkUpdateSupportedConnectorTypes operation in ConnectorsApi.
 */
export interface ConnectorsApiBulkUpdateSupportedConnectorTypesRequest {
    readonly connectorIntegrationBulkUpdate: ConnectorIntegrationBulkUpdate
}

/**
 * Request parameters for createConnector operation in ConnectorsApi.
 */
export interface ConnectorsApiCreateConnectorRequest {
    readonly createConnectorRequest: CreateConnectorRequest
}

/**
 * Request parameters for deleteConnector operation in ConnectorsApi.
 */
export interface ConnectorsApiDeleteConnectorRequest {
    readonly connectorId: string
}

/**
 * Request parameters for getBitbucketRepositories operation in ConnectorsApi.
 */
export interface ConnectorsApiGetBitbucketRepositoriesRequest {
    readonly connectorId: string
}

/**
 * Request parameters for getConnector operation in ConnectorsApi.
 */
export interface ConnectorsApiGetConnectorRequest {
    readonly connectorId: string
}

/**
 * Request parameters for getGithubRepositories operation in ConnectorsApi.
 */
export interface ConnectorsApiGetGithubRepositoriesRequest {
    readonly connectorId: string
}

/**
 * Request parameters for handleOauthCallback operation in ConnectorsApi.
 */
export interface ConnectorsApiHandleOauthCallbackRequest {
    readonly connectorType: ConnectorType

    readonly oAuthCallbackRequest: OAuthCallbackRequest
}

/**
 * Request parameters for initiateOauth operation in ConnectorsApi.
 */
export interface ConnectorsApiInitiateOauthRequest {
    readonly connectorType: ConnectorType
}

/**
 * Request parameters for listGoogleDriveFiles operation in ConnectorsApi.
 */
export interface ConnectorsApiListGoogleDriveFilesRequest {
    readonly connectorId: string

    readonly googleDriveFilesRequest: GoogleDriveFilesRequest
}

/**
 * Request parameters for reauthorizeConnector operation in ConnectorsApi.
 */
export interface ConnectorsApiReauthorizeConnectorRequest {
    readonly connectorId: string
}

/**
 * Request parameters for revokeConnector operation in ConnectorsApi.
 */
export interface ConnectorsApiRevokeConnectorRequest {
    readonly connectorId: string
}

/**
 * Request parameters for updateConnector operation in ConnectorsApi.
 */
export interface ConnectorsApiUpdateConnectorRequest {
    readonly connectorId: string

    readonly updateConnectorRequest: UpdateConnectorRequest
}

/**
 * Request parameters for updateSupportedConnectorTypes operation in ConnectorsApi.
 */
export interface ConnectorsApiUpdateSupportedConnectorTypesRequest {
    readonly connectorIntegrationUpdate: ConnectorIntegrationUpdate
}

/**
 * ConnectorsApi - object-oriented interface
 */
export class ConnectorsApi extends BaseAPI {
    /**
     * Update multiple organization integration\'s enabled status.
     * @summary Update Supported Connector Types
     * @param {ConnectorsApiBulkUpdateSupportedConnectorTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkUpdateSupportedConnectorTypes(requestParameters: ConnectorsApiBulkUpdateSupportedConnectorTypesRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).bulkUpdateSupportedConnectorTypes(requestParameters.connectorIntegrationBulkUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new connector with OAuth credentials
     * @summary Create Connector
     * @param {ConnectorsApiCreateConnectorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createConnector(requestParameters: ConnectorsApiCreateConnectorRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).createConnector(requestParameters.createConnectorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a connector and its associated OAuth tokens
     * @summary Delete Connector
     * @param {ConnectorsApiDeleteConnectorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteConnector(requestParameters: ConnectorsApiDeleteConnectorRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).deleteConnector(requestParameters.connectorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Bitbucket Repositories
     * @param {ConnectorsApiGetBitbucketRepositoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBitbucketRepositories(requestParameters: ConnectorsApiGetBitbucketRepositoriesRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).getBitbucketRepositories(requestParameters.connectorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific connector by ID
     * @summary Get Connector
     * @param {ConnectorsApiGetConnectorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConnector(requestParameters: ConnectorsApiGetConnectorRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).getConnector(requestParameters.connectorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Github Repositories
     * @param {ConnectorsApiGetGithubRepositoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGithubRepositories(requestParameters: ConnectorsApiGetGithubRepositoriesRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).getGithubRepositories(requestParameters.connectorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all supported OAuth connector types
     * @summary Get Supported Connector Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSupportedConnectorTypes(options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).getSupportedConnectorTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exchange authorization code for OAuth tokens
     * @summary Handle OAuth Callback
     * @param {ConnectorsApiHandleOauthCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public handleOauthCallback(requestParameters: ConnectorsApiHandleOauthCallbackRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).handleOauthCallback(requestParameters.connectorType, requestParameters.oAuthCallbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate authorization URL to start OAuth flow for a connector type
     * @summary Initiate OAuth Flow
     * @param {ConnectorsApiInitiateOauthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public initiateOauth(requestParameters: ConnectorsApiInitiateOauthRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).initiateOauth(requestParameters.connectorType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all connectors for the current user
     * @summary List Connectors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listConnectors(options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).listConnectors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List files and folders in Google Drive with pagination.
     * @summary List Google Drive Files
     * @param {ConnectorsApiListGoogleDriveFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listGoogleDriveFiles(requestParameters: ConnectorsApiListGoogleDriveFilesRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).listGoogleDriveFiles(requestParameters.connectorId, requestParameters.googleDriveFilesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate OAuth flow to refresh expired connector credentials
     * @summary Re-authorize Connector
     * @param {ConnectorsApiReauthorizeConnectorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reauthorizeConnector(requestParameters: ConnectorsApiReauthorizeConnectorRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).reauthorizeConnector(requestParameters.connectorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke the connector\'s OAuth credentials at the provider and clear the stored tokens
     * @summary Revoke Connector
     * @param {ConnectorsApiRevokeConnectorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revokeConnector(requestParameters: ConnectorsApiRevokeConnectorRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).revokeConnector(requestParameters.connectorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing connector
     * @summary Update Connector
     * @param {ConnectorsApiUpdateConnectorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateConnector(requestParameters: ConnectorsApiUpdateConnectorRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).updateConnector(requestParameters.connectorId, requestParameters.updateConnectorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an organization integration\'s enabled status.
     * @summary Update Supported Connector Types
     * @param {ConnectorsApiUpdateSupportedConnectorTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSupportedConnectorTypes(requestParameters: ConnectorsApiUpdateSupportedConnectorTypesRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).updateSupportedConnectorTypes(requestParameters.connectorIntegrationUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

